import { Box, Chip, Tooltip } from '@mui/material';
import { ReadOnly, Select, useEntityPermission } from '@ui-framework/index';
import { observer } from 'mobx-react';
import React, { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

const UserStatusSelect = forwardRef(
  ({ overwriteProps = {}, customConfig, ...props }, ref) => {
    const options = [
      { label: 'Enabled', value: true },
      { label: 'Disabled', value: false },
    ];
    const { getValues } = useFormContext();
    const { isHidden, isReadOnly } = useEntityPermission();

    const currentvalue = getValues(props?.field?.name);
    const disabledReason = getValues(
      props?.field?.dependencies?.disabledReason || 'disabledReason',
    );

    if (isReadOnly(props?.permission, currentvalue)) {
      return (
        <ReadOnly name={props?.name}>
          <Box>{options.find(i => i.value === currentvalue)?.label}</Box>
          <Box>{disabledReason}</Box>
        </ReadOnly>
      );
    }

    if (isHidden(props?.permission)) {
      return (
        <input type="hidden" name={props?.field?.name} value={currentvalue} />
      );
    }

    return (
      <Box>
        <Box>
          <Select
            ref={ref}
            options={options}
            {...props}
            overwriteProps={overwriteProps}
          />
        </Box>
        {disabledReason && (
          <Box sx={{ mt: 0.5 }}>
            <Tooltip arrow title={disabledReason}>
              <Chip
                size="small"
                rounded={0}
                label={disabledReason}
                color="error"
                variant="outlined"
              />
            </Tooltip>
          </Box>
        )}
      </Box>
    );
  },
);

export default observer(UserStatusSelect);
